import * as angular from "angular";
import { DataSet } from "../models/data-set.model";
import { DataSetService } from "../services/data-set.service";

export class DataSetDataProvider {
    private $q: any;
    private $timeout: any;
    private service: DataSetService;

    private dataSets: DataSet[] | null = null;
    private selectedDataSet: object | null = null;
    private getDataSetPromise: any = null;
    private inProgressCalled: boolean = false;
    private getDataSetInProgressPromise: any = null;

    constructor($q: any, DataSetService: DataSetService, $timeout: any) {
        this.$q = $q;
        this.$timeout = $timeout;
        this.service = DataSetService;
    }

    clearAll() {
        this.dataSets = null;
        this.selectedDataSet = null;
        this.getDataSetPromise = null;
        this.inProgressCalled = false;
        this.getDataSetInProgressPromise = null;
    }

    getDataSets(): Promise<any> {
        const deferred = this.$q.defer();
        if (this.dataSets !== null) {
            deferred.resolve(this.dataSets);
            this.getDataSetPromise = deferred.promise;
            return this.getDataSetPromise;
        } else if (this.getDataSetPromise) {
            return this.getDataSetPromise;
        } else {
            this.service.all().then(
                (response: object) => {
                    const json = response["data"];
                    this.dataSets = [];
                    for (let i = 0; i < json.data.length; i++) {
                        this.dataSets.push(new DataSet(json.data[i]));
                    }
                    deferred.resolve(this.dataSets);
                },
                (error: object) => {
                    this.dataSets = [];
                    deferred.reject(error);
                }
            );
            this.getDataSetPromise = deferred.promise;
            return this.getDataSetPromise;
        }
    }

    info(consentedType: boolean): Promise<any> {
        const deferred = this.$q.defer();
        this.service.info({ consentedtype: consentedType }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    anonymize(consentedType: boolean): Promise<any> {
        const deferred = this.$q.defer();
        this.service.anonymize({ consentedtype: consentedType }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve();
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getDataSetInProgress(): boolean {
        if (!this.inProgressCalled) {
            this.inProgressCalled = true;
            this.getDataSets();
        } else {
            if (this.dataSets) {
                if (
                    this.dataSets.length &&
                    this.dataSets[this.dataSets.length - 1].status ===
                        "In Progress"
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    processSocketUpdate(socketData: any): void {
        if (this.dataSets) {
            this.replaceDataSet(socketData.data);
        }
    }

    processSocketCreate(socketData: any): void {
        if (this.dataSets) {
            this.replaceDataSet(socketData.data);
        }
    }

    replaceDataSet(dataSet: DataSet): void {
        this.$timeout(() => {
            let existingDataSet = this.dataSetWithID(dataSet.id);
            if (existingDataSet) {
                angular.extend(existingDataSet, dataSet);
            } else {
                this.dataSets.push(dataSet);
            }
        });
    }

    dataSetWithID(id: string): DataSet {
        const lastDataSet = this.dataSets.length - 1;
        if (this.dataSets[lastDataSet].id == id) {
            return this.dataSets[lastDataSet];
        }
        return null;
    }
}

angular
    .module("vcDataProvider")
    .service("DataSetDataProvider", DataSetDataProvider);
